import { useState, useEffect } from 'react';

export const useDebounce = (func: () => void, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(func);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(func), delay);
    return () => clearTimeout(handler);
  }, [func, delay]);

  return debouncedValue;
};
